import "./error.scss"
const Error = () => {
  return (
    <div className='error'></div>
  )
}

export default Error